import { Injectable } from '@angular/core';
import { Observable, of, throwError, from } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import {Menus} from '../../Models/menus';



const apiUrl = "../datas/menus.json";

@Injectable({
  providedIn: 'root'
})
export class MenusService {

  constructor(private http:HttpClient) { }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getMenus (): Observable<Menus[]> {
    return this.http.get<Menus[]>(apiUrl)
      .pipe(
        tap(),
        catchError(this.handleError('getMenus', []))
      );
  }
}
